import { post } from 'api/post';
import { buildErrorPayload } from 'state/buildErrorPayload';
import { appendStatus } from 'state/status/actions';

import _ from 'lodash';

export const AUTH_RESET_PASSWORD_REQUEST = 'auth/reset-password/request';
export const AUTH_RESET_PASSWORD_SUCCESS = 'auth/reset-password/success';
export const AUTH_RESET_PASSWORD_FAILURE = 'auth/reset-password/failure';


export function sendResetPassword(email) {

  return async dispatch => {
    try {
      await post('resetpw', {
        email: email
      });

      dispatch({
        type: AUTH_RESET_PASSWORD_SUCCESS,
        payload: null
      });

    }
    catch (error) {
      if (error.response.status === 422) {

        dispatch({
          type: AUTH_RESET_PASSWORD_FAILURE,
          payload: _.get(error.response, 'data.payload', null)
        });
      }
      else {

        const errPayload = buildErrorPayload(error);
        dispatch({
          type: SAVE_VERIFICATION_DATA_FAILURE,
          payload: null
        });

        dispatch(appendStatus(errPayload.errorMessage, 'error'));
      }
    }
  }
}
